import React from "react";
import downloadScreen from "../assets/images/Mobile-Screen.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const Downloads = () => {
  return (
    <div className="w-full md:w-981 flex justify-center h-auto md:h-100 bg-[#eeeeee]">
      <div className="downloads-container flex flex-col md:flex-row justify-center items-center">
        <div className="p-5 md:p-10 mr-0 md:mr-20">
          <img
            src={downloadScreen}
            alt="Shadow"
            width={300}
            className="h-[572px] download-img"
          />
        </div>
        <div className="text-center md:text-left pb-4 sm:pb-8">
          <h2 className="text-lg font-extrabold">
            <span className="font-bold text-2xl md:text-4xl">Download </span>
            <span className="font-bold text-2xl md:text-4xl text-[#12AD63]">
              NutriLens{" "}
            </span>
            <span className="font-bold text-2xl md:text-4xl">AI.</span>
          </h2>
          <div className="flex mt-4 justify-center sm:justify-start items-center">
            <div className="inline-block mr-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.sstech.nutrilens"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlayStore}
                  alt="Google Play Store"
                  className="h-[60px] w-auto"
                />
              </a>
            </div>
            <div className="inline-block">
              <a
                href="https://apps.apple.com/in/app/nutrilens-ai-calorie-counter/id6776608256"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applerPlayStore}
                  alt="Apple App Store"
                  className="h-[60px] w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
